export const actions = {
    SHOW_SNACKBAR_MESSAGE: 'SHOW_SNACKBAR_MESSAGE',
    HIDE_SNACKBAR_MESSAGE: 'HIDE_SNACKBAR_MESSAGE'
};

const INITIAL_STATE = {
    snackbarMessage: {
        content: '',
        show: false
    }
};

const updateSnackbar = (state, content, show) => {
    const newState = {
        ...state,
        snackbarMessage: {
            ...state.snackbarMessage,
            content,
            show
        }
    };
    return newState;
};

const showSnackbar = (state, action) => {
    if (!state.snackbarMessage.show) {
        return updateSnackbar(state, action.content, true);
    }
    return state;
};

const hideSnackbar = (state, action) => {
    return updateSnackbar(state, state.snackbarMessage.content, false);
};

const handlers = {
    [actions.SHOW_SNACKBAR_MESSAGE]: showSnackbar,
    [actions.HIDE_SNACKBAR_MESSAGE]: hideSnackbar
};

export default function systemReducer(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) return state;
    return handler(state, action);
}

export const getSnackbar = (state) => {
    return state.snackbarMessage;
};
